import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SidebarMain from "./components/shared/Sidebar";
import DiscoverPage from "./components/discover/DiscoverPage";
import ParkingList from "./components/parking/ParkingList";
import Profile from "./components/auth/Profile";
import Login from "./components/auth/Login";
import { NotificationProvider } from "./context/NotificationContext";
import AdvalvasPage from "./components/advalvas/AdvalvasPage";
import Management from "./components/management/Management";
import Settings from "./components/auth/Settings";
import Register from "./components/auth/Register";
import Leaderboard from "./components/leaderboard/Leaderboard";
import Rewards from "./components/leaderboard/Rewards";
import UserOnboarding from "./components/auth/UserOnboarding";
import RequestSubmittedPage from "./components/auth/RequestSubmittedPage";
import { ProtectedRoute } from "blitzware-react-sdk";
import AuthWrapper from "./components/auth/AuthWrapper";
import RoleProtectedRoute from "./components/auth/RoleProtectedRoute";
import { SyncedUserProvider } from "./context/SyncedUserContext";

function App() {
  return (
    <Router>
      <NotificationProvider>
        <SyncedUserProvider>
          <div className="h-screen bg-gray-100 dark:bg-neutral-900 w-full">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/onboarding" element={<UserOnboarding />} />
              <Route
                path="/request-submitted"
                element={<RequestSubmittedPage />}
              />
              <Route
                path="/*"
                element={
                  <AuthWrapper>
                    <div className="flex">
                      <SidebarMain />
                      <main className="flex-1 overflow-y-auto w-full">
                        <Routes>
                          <Route
                            path="/"
                            element={
                              <ProtectedRoute component={AdvalvasPage} />
                            }
                          />
                          <Route
                            path="parking"
                            element={<ProtectedRoute component={ParkingList} />}
                          />
                          <Route
                            path="discover"
                            element={
                              <ProtectedRoute component={DiscoverPage} />
                            }
                          />
                          <Route
                            path="leaderboard"
                            element={<ProtectedRoute component={Leaderboard} />}
                          />
                          <Route
                            path="rewards"
                            element={<ProtectedRoute component={Rewards} />}
                          />
                          <Route
                            path="discover/:category"
                            element={
                              <ProtectedRoute component={DiscoverPage} />
                            }
                          />
                          <Route
                            path="profile"
                            element={<ProtectedRoute component={Profile} />}
                          />
                          <Route
                            path="settings"
                            element={<ProtectedRoute component={Settings} />}
                          />
                          <Route
                            path="management"
                            element={
                              <RoleProtectedRoute requiredRole={2}>
                                <Management />
                              </RoleProtectedRoute>
                            }
                          />
                        </Routes>
                      </main>
                    </div>
                  </AuthWrapper>
                }
              />
            </Routes>
          </div>
        </SyncedUserProvider>
      </NotificationProvider>
    </Router>
  );
}

export default App;
